import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const NextStep = ({ kicker, title, text, to, testid }) => (
  <Link to={to} data-testid={testid}
    className="group mt-16 flex flex-col sm:flex-row sm:items-center justify-between gap-4 rounded-2xl border border-[#FF7A00]/30 bg-[#FF7A00]/[0.06] p-6 lg:p-8 hover:border-[#FF7A00] transition-colors">
    <div>
      <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#FF7A00]/80">{kicker}</span>
      <h3 className="text-xl lg:text-2xl font-bold mt-1 group-hover:text-[#FF7A00] transition-colors">{title}</h3>
      <p className="text-sm text-white/50 mt-1 max-w-xl">{text}</p>
    </div>
    <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#FF7A00] whitespace-nowrap">
      Continue <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
    </span>
  </Link>
);
